// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"ResolvePayment_pageHeader__2ThUZ","paymentSuccessAlert":"ResolvePayment_paymentSuccessAlert__3Fg6Q"};